import React from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

const customStyle = makeStyles({
  bodyBgColor: {
    backgroundColor: "white",
  },
  bgSolution: {
    backgroundImage: "url('/images/bgSolution.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "12%",
    backgroundPosition: "right 17% center",
  },
  cardHover: {
    backgroundColor: "#f5f9fa",
    padding: "40px",
    transition: "0.5s all",
    "&:hover": {
      backgroundColor: "white",
      boxShadow: "rgba(0, 0, 0, 10%) 0px 7px 20px 0px",
      transition: "0.5s all",
    },
  },
  aboutUsText: {},
  demoButton: {
    backgroundColor: "#FFFFFF !important",
    color: "#31B9B5 !important",
    fontWeight: "bold !important",
    "&:hover": {
      backgroundColor: "#f7f4f4 !important",
      color: "#31B9B5 !important",
      fontWeight: "bold !important",
    },
  },
});




const AboutUs = () => {
  const classes = customStyle();
  return (
  
       <Container maxWidth="xl">
     
        <Box className={classes.bodyBgColor} id="about-us">
        <section id="aboutus">
            <Grid container alignItems="center">
              <Grid
                item
                xs={12}
                md={12}
                textAlign="center"
                px={{ xs: 2 }}
                my={{ xs: 5, md: 10 }}
              >
                <Typography mb={2} variant={"h4"} fontWeight={"bold"}>
                  About Us
                </Typography>

                <Typography
                  mb={5}
                  textAlign={"justify"}
                  fontFamily={"DM Sans"}
                  fontSize={"24px"}
                  color={"#221F1F"}
                  fontWeight={400}
                >
                  AmitaSoft is a leading mortgage expert in creating great
                  platforms for mortgage loan officers, borrowers and lenders.
                  With intuitive interface and state of art features and
                  capabilities, our applications are more than just applications
                  for our customers- they are genies for life! We reimagine the
                  mortgage loan process so that our customers can realize their
                  dreams.
                </Typography>
              </Grid>
            </Grid>
            </section>
        </Box>
     
      </Container>
  
  )
}

export default AboutUs
